import React from "react";
import "./InstantAccess.css";
import image from "./desktop--new.webp";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGooglePlay,faApple
} from "@fortawesome/free-brands-svg-icons";
const InstantAccess = () => {
  const navigate = useNavigate();
  const HandleClick = () => {
    navigate("/login");
  };
  return (
    <>
      <main className="instant-access-area">
        <section className="svelte-1kda84f" data-id="welcome">
          <div className="layout svelte-iq32t8"></div>
          <div className="layout svelte-iq32t8">
            <div className="flex-container svelte-1kda84f" dir="ltr">
              <div className="svelte-htahf5" dir="ltr">
                <div className="text-content svelte-htahf5">
                  <h1 className="en svelte-htahf5">
                    Instant access to investing, anytime and anywhere
                  </h1>
                  <h2 className="svelte-1kda84f">
                    Investing has never been easier. Everything you are looking
                    for in an ultimate investment platform — on the device of
                    your choice.
                  </h2>
                  <div className="btns svelte-1kda84f">
                    <div slot="desktop">
                      <button
                        className="svelte-1mmfu6d"
                        aria-label="sign up"
                        dir="ltr"
                        onClick={HandleClick}
                      >
                        Register account
                      </button>
                    </div>
                  </div>
                  <section className="icons svelte-xnqnze">
                    <div className="svg-icon svelte-xnqnze">
                    <FontAwesomeIcon icon={faApple} />
                    </div>
                    <div className="svg-icon svelte-xnqnze">
                   <FontAwesomeIcon icon={faGooglePlay} />
                    </div>
                  </section>
                </div>
              </div>
              <div className="platform desktop svelte-otrisl">
                <picture className="platform-picture svelte-otrisl">
                  <source srcset={image} type="image/webp" />
                  <img
                    alt="Platform"
                    src={image}
                    className="platform-img svelte-otrisl"
                  />
                </picture>
              </div>
            </div>
          </div>
        </section>
{/* 
        <section className="svelte-1l65qup" dir="ltr">
          <div className="layout svelte-iq32t8">
            <div className="advantages-list svelte-1l65qup">
              <div className="advantage svelte-1l65qup">
                <div className="title svelte-1l65qup" data-test-id="">
                  No demo account
                </div>
                <div className="subtitle svelte-1l65qup">
                  Test your investing approach with a free demo account
                </div>
              </div>
              <div className="advantage svelte-1l65qup">
                <div
                  className="title svelte-1l65qup"
                  data-test-id="minimum-deposit"
                >
                  $50 minimum deposit
                </div>
                <div className="subtitle svelte-1l65qup">
                  No fees when you make a deposit or withdraw funds
                </div>
              </div>
              <div className="advantage svelte-1l65qup">
                <div className="title svelte-1l65qup" data-test-id="">
                  $50 minimum investment
                </div>
                <div className="subtitle svelte-1l65qup">
                  You may start with small amounts of money
                </div>
              </div>
            </div>
          </div>
        </section> */}
      </main>
    </>
  );
};

export default InstantAccess;
